import Action from '../action';
import { ActionTypes } from '../login/auth';
import { ManagerPermission } from '../permission-profiles/permission';

interface PendingActionsPayload {
    vendorsPost?: number;
    vendorUsersPost?: number;
    vendorBranchesPost?: number;
    beneficiaryImportsPost?: number;
    beneficiarySignatures?: number;
    beneficiaryBlock?: number;
    beneficiaryUnblock?: number;
    beneficiaryZero?: number;
    beneficiaryImportsCancel?: number;
    alternativeCollectorImport?: number;
    removeAlternativeCollectorImport?: number;
    documentsUpload?: number;
    usersPost?: number;
    adjustmentsTransactions?: number;
    adjustmentsBeneficiaryBlock?: number;
    adjustmentsBeneficiaryUnblock?: number;
    adjustmentsBeneficiaryZeroingBlock?: number;
    adjustmentsBeneficiaryZeroing?: number;
    adjustmentsBeneficiaryDetails?: number;
    alternativeCollectorStatusChange?: number;
    adjustmentsVendors?: number;
    adjustmentsUsers?: number;
    adjustmentsVendorUserDetails?: number;
    adjustmentsPartners?: number;
    adjustmentsPartnerUserDetails?: number;
    adjustmentsLocations?: number;
    adjustmentsPermissionProfiles?: number;
    adjustmentsProductManagement?: number;
    adjustmentsProductManagementSignature?: number;
    adjustmentsMobileDevices?: number;
    adjustmentsBranchCodes?: number;
    adjustmentsProductPriceVersions?: number;
    adjustmentsProductDetails?: number;
    partnersPost?: number;
    partnerUsersPost?: number;
    paymentGenerate?: number;
    paymentCancelPost?: number;
    paymentIssuePost?: number;
    paymentIssuePark?: number;
    paymentParkPaid?: number;
    paymentPostPaid?: number;
    paymentGenerationPark?: number;
    locationsPost?: number;
    permissionProfilePost?: number;
    mobileDevicesPost?: number;
}

export class BeneficiariesPendingActions {
    upload: number;
    block: number;
    unblock: number;
    zero: number;
    cancelImport: number;
    alternativeCollectorImport: number;
    removeAlternativeCollectorImport: number;

    constructor(
        upload = 0,
        sign = 0,
        block = 0,
        unblock = 0,
        zero = 0,
        cancelImport = 0,
        alternativeCollectorImport = 0,
        removeAlternativeCollectorImport = 0,
        permissions: Array<string> = []
    ) {
        this.upload =
            (permissions.includes(ManagerPermission.beneficiariesEntitlementVerify) ? upload : 0) +
            (permissions.includes(ManagerPermission.beneficiariesSignLevelOne) ||
            permissions.includes(ManagerPermission.beneficiariesSignLevelTwo)
                ? sign
                : 0);
        this.block = permissions.includes(ManagerPermission.beneficiariesMassBlockPost) ? block : 0;
        this.unblock = permissions.includes(ManagerPermission.beneficiariesMassUnblockPost) ? unblock : 0;
        this.zero = permissions.includes(ManagerPermission.beneficiariesMassZeroPost) ? zero : 0;
        this.cancelImport =
            permissions.includes(ManagerPermission.beneficiariesSignLevelOne) ||
            permissions.includes(ManagerPermission.beneficiariesSignLevelOne)
                ? cancelImport
                : 0;
        this.alternativeCollectorImport = permissions.includes(ManagerPermission.alternativeCollectorsImportPost)
            ? alternativeCollectorImport
            : 0;
        this.removeAlternativeCollectorImport = permissions.includes(
            ManagerPermission.removeAlternativeCollectorsImportPost
        )
            ? removeAlternativeCollectorImport
            : 0;
    }
}

export class AdjustmentsPendingActions {
    transactions: number;
    beneficiaries: number;
    vendors: number;
    users: number;
    vendorUsers: number;
    preParkedBeneficiaries: number;
    partners: number;
    partnerUsers: number;
    locationActions: number;
    permissionsProfiles: number;
    products: number;
    productSignatures: number;
    mobileDevices: number;
    branchCodes: number;
    productPriceVersions: number;
    productDetails: number;

    constructor(
        transactions = 0,
        beneficiaries: Record<string, number>,
        vendors = 0,
        users = 0,
        vendorUsers = 0,
        permissions: Array<string> = [],
        partners: number,
        partnerUsers: number,
        locationActions = 0,
        permissionsProfiles = 0,
        products = 0,
        productSignatures = 0,
        mobileDevices = 0,
        branchCodes = 0,
        productPriceVersions = 0,
        productDetails = 0
    ) {
        // preParkedBeneficiaries: number = 0,
        this.transactions = permissions.includes(ManagerPermission.transactionRequestPost) ? transactions : 0;
        this.beneficiaries =
            (permissions.includes(ManagerPermission.beneficiariesSingleBlockPost) ? beneficiaries.block : 0) +
            (permissions.includes(ManagerPermission.beneficiariesSingleUnblockPost) ? beneficiaries.unblock : 0) +
            (permissions.includes(ManagerPermission.beneficiariesSingleZeroPost) ? beneficiaries.zero : 0) +
            (permissions.includes(ManagerPermission.beneficiariesPost) ? beneficiaries.details : 0) +
            (permissions.includes(ManagerPermission.beneficiariesSingleZeroPost) &&
            permissions.includes(ManagerPermission.beneficiariesSingleBlockPost)
                ? beneficiaries.zeroBlock
                : 0) +
            (permissions.includes(ManagerPermission.alternativeCollectorStatusChangePost)
                ? beneficiaries.alternativeCollectorStatusChange
                : 0);
        this.vendors = permissions.includes(ManagerPermission.vendorsPost) ? vendors : 0;
        this.users = permissions.includes(ManagerPermission.managersManagementPost) ? users : 0;
        this.vendorUsers = permissions.includes(ManagerPermission.vendorUserPost) ? vendorUsers : 0;
        this.preParkedBeneficiaries = 0; //permissions.includes(ManagerPermission.beneficiariesPost) || permissions.includes(ManagerPermission.beneficiariesPark) ? preParkedBeneficiaries : 0
        this.partners = permissions.includes(ManagerPermission.partnerUserPost) ? partners : 0;
        this.partnerUsers = permissions.includes(ManagerPermission.partnerUserPost) ? partnerUsers : 0;
        this.locationActions = permissions.includes(ManagerPermission.beneficiariesPark) ? locationActions : 0;
        this.products = permissions.includes(ManagerPermission.productGroupPricesView) ? products : 0;
        this.permissionsProfiles = permissions.includes(ManagerPermission.managersManagementPost)
            ? permissionsProfiles
            : 0;
        this.productSignatures = productSignatures || 0;
        this.mobileDevices = permissions.includes(ManagerPermission.mobileDevicesCreateUpdatePost) ? mobileDevices : 0;
        this.branchCodes = permissions.includes(ManagerPermission.vendorsPost) ? branchCodes : 0;
        this.productPriceVersions = permissions.includes(ManagerPermission.productGroupUpdateVendorBranch)
            ? productPriceVersions
            : 0;
        this.productDetails = productDetails || 0;
    }
}

export class PendingActionsState {
    vendorsPost: number;
    vendorUsersPost: number;
    vendorBranchesPost: number;
    beneficiaries: BeneficiariesPendingActions;
    usersPost: number;
    adjustments: AdjustmentsPendingActions;
    partnersPost: number;
    partnerUsersPost: number;
    paymentsActions: number;
    locationsPost: number;
    documentsUpload: number;
    permissionProfilePost: number;
    mobileDevicesPost: number;

    constructor(payload: Record<string, unknown> = {}) {
        const pendingAction = (payload.pendingActions ? payload.pendingActions : {}) as PendingActionsPayload;
        const permissions = (payload.permissions ? payload.permissions : []) as string[];
        this.vendorsPost = permissions.includes(ManagerPermission.vendorsPost) ? pendingAction.vendorsPost : 0;
        this.vendorUsersPost = permissions.includes(ManagerPermission.vendorUserPost)
            ? pendingAction.vendorUsersPost
            : 0;
        this.vendorBranchesPost = permissions.includes(ManagerPermission.vendorsPost)
            ? pendingAction.vendorBranchesPost
            : 0;

        this.vendorsPost += this.vendorUsersPost;
        this.vendorsPost += this.vendorBranchesPost;

        this.beneficiaries = new BeneficiariesPendingActions(
            pendingAction.beneficiaryImportsPost,
            pendingAction.beneficiarySignatures,
            pendingAction.beneficiaryBlock,
            pendingAction.beneficiaryUnblock,
            pendingAction.beneficiaryZero,
            pendingAction.beneficiaryImportsCancel,
            pendingAction.alternativeCollectorImport,
            pendingAction.removeAlternativeCollectorImport,
            permissions
        );
        this.documentsUpload = pendingAction.documentsUpload;
        this.usersPost = permissions.includes(ManagerPermission.managersManagementPost) ? pendingAction.usersPost : 0;
        this.adjustments = new AdjustmentsPendingActions(
            pendingAction.adjustmentsTransactions,
            {
                block: pendingAction.adjustmentsBeneficiaryBlock,
                unblock: pendingAction.adjustmentsBeneficiaryUnblock,
                zeroBlock: pendingAction.adjustmentsBeneficiaryZeroingBlock,
                zero: pendingAction.adjustmentsBeneficiaryZeroing,
                details: pendingAction.adjustmentsBeneficiaryDetails,
                alternativeCollectorStatusChange: pendingAction.alternativeCollectorStatusChange,
            },
            pendingAction.adjustmentsVendors,
            pendingAction.adjustmentsUsers,
            pendingAction.adjustmentsVendorUserDetails,
            permissions,
            pendingAction.adjustmentsPartners,
            pendingAction.adjustmentsPartnerUserDetails,
            pendingAction.adjustmentsLocations,
            pendingAction.adjustmentsPermissionProfiles,
            pendingAction.adjustmentsProductManagement,
            pendingAction.adjustmentsProductManagementSignature,
            pendingAction.adjustmentsMobileDevices,
            pendingAction.adjustmentsBranchCodes,
            pendingAction.adjustmentsProductPriceVersions,
            pendingAction.adjustmentsProductDetails
        );
        this.partnersPost = permissions.includes(ManagerPermission.partnerPost) ? pendingAction.partnersPost : 0;
        this.partnersPost += permissions.includes(ManagerPermission.partnerUserPost)
            ? pendingAction.partnerUsersPost
            : 0;
        this.partnerUsersPost = permissions.includes(ManagerPermission.partnerUserPost)
            ? pendingAction.partnerUsersPost
            : 0;
        this.paymentsActions =
            (permissions.includes(ManagerPermission.paymentsGeneratePost) ? pendingAction.paymentGenerate || 0 : 0) +
            (permissions.includes(ManagerPermission.paymentsGeneratePost) ? pendingAction.paymentCancelPost || 0 : 0) +
            (permissions.includes(ManagerPermission.paymentIssuePost) ? pendingAction.paymentIssuePost || 0 : 0) +
            (permissions.includes(ManagerPermission.paymentIssuePark) ? pendingAction.paymentIssuePark || 0 : 0) +
            (permissions.includes(ManagerPermission.paymentsPaidPark) ? pendingAction.paymentParkPaid || 0 : 0) +
            (permissions.includes(ManagerPermission.paymentsPaidPost) ? pendingAction.paymentPostPaid || 0 : 0) +
            (permissions.includes(ManagerPermission.paymentsGeneratePark)
                ? pendingAction.paymentGenerationPark || 0
                : 0);
        this.locationsPost = permissions.includes(ManagerPermission.beneficiariesPark)
            ? pendingAction.locationsPost
            : 0;
        this.permissionProfilePost = permissions.includes(ManagerPermission.profilesPost)
            ? pendingAction.permissionProfilePost
            : 0;
        this.mobileDevicesPost = permissions.includes(ManagerPermission.mobileDevicesCreateUpdatePost)
            ? pendingAction.mobileDevicesPost
            : 0;
    }
}

export const ActionCreators = {};

export function pendingActionsReducer(state: PendingActionsState = new PendingActionsState(), action: Action) {
    switch (action.type) {
        case ActionTypes.loadedPendingActions:
            return new PendingActionsState(action.payload as Record<string, unknown>);
    }
    return state;
}
